import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

export default function ViewTicket() {
  const { id } = useParams();
  const { token } = useAuth();
  const [ticket, setTicket] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTicket(res.data);
      } catch (err) {
        setError('Ticket not found or failed to load.');
      }
    };

    if (token) fetchTicket();
  }, [id, token]);

  if (!token) return <p>Please log in to view the ticket.</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!ticket) return <p>Loading...</p>;
  
  return (
    <div className="container mt-4">
      <h2>Ticket Details</h2>
      <p><strong>Subject:</strong> {ticket.subject}</p>
      <p><strong>Description:</strong> {ticket.description}</p>
      <p><strong>Status:</strong> {ticket.status}</p>
      <p><strong>Priority:</strong> {ticket.priority}</p>
      <div className="mb-3">
        <strong>IT Remark:</strong>
        <p>{ticket.remark}</p>
      </div>
      {ticket.attachments?.length > 0 && (
        <div className="mb-3">
          <h5>Attachments</h5>
          <ul>
            {ticket.attachments.map((filename, index) => (
              <li key={index}>
                <a
                  href={`${process.env.REACT_APP_API_URL}/uploads/${filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {filename}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      <p><strong>Last Update:</strong> {formatDate(ticket.updatedAt)}</p>

      <Link to="/tickets" className="btn btn-sm btn-outline-secondary me-2">Back</Link>
    </div>
  );
}
